
































import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { examCreateModule } from '@/store/modules/frames/exam-create.module';
import { GPageBase } from '@/mixins';
import { GEnum } from '@/constants/enum.defination';
import GImportModal from '@/components/GImportModal.vue';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import * as XLSX from 'xlsx';
import { importModalModule } from '@/store/modules/frames/import-modal.module';

@Component({
  name: 'GExamDetailEvalRequestModal',
  components: { GImportModal },
  computed: {},
  methods: {},
})
export default class GExamDetailEvalRequestModal extends Mixins(GPageBase) {
  modalEvalRequest: boolean = false;
  showConfirmModal: boolean = false;
  entryCount: number = 0;

  mounted() {}

  @Prop() value: boolean;

  @Watch('value')
  openModal(value: boolean) {
    this.modalEvalRequest = value;
  }

  @Watch('modalEvalRequest')
  close(value: boolean) {
    this.$emit('input', value);
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  handleEvalRequestTemplateDownload() {
    examCreateModule.downloadRequestTemplate(this.evalSettingDetail.evalSettingID).then(() => {
      importModalModule.setIsDownloading(false);
    });
  }

  handleEvalRequestUpload(workBook: XLSX.WorkBook) {
    this.entryCount =
      XLSX.utils.sheet_to_json(workBook.Sheets['request_list']).filter((rowObject: any) => {
        // 多言語対応 : シート名やセルの値も多言語対応するのか微妙なため保留
        if (rowObject.hasOwnProperty('受検者') && rowObject.hasOwnProperty('評価者')) {
          // 受検者、評価者が書かれている行のみ件数を取得
          return true;
        }
      }).length - 1;
    if (this.entryCount < 0) {
      this.entryCount = 0;
    }
    this.showConfirmModal = true;
  }

  handleOK(formData: FormData) {
    examCreateModule
      .importRequestTemplate({
        formData: formData,
        evalSettingID: this.evalSettingDetail.evalSettingID,
      })
      .then((response: any) => {
        if (response) {
          this.showNotice(GEnum.MessageType.Success, this.$t('REGISTER_EVAL_REQUEST').toString(), this.$t('MESSAGE_COMPLETE_REGISTER_EVAL_REQUEST', {value: response.data.registrationCount}).toString(), 10);
          this.$emit('input', false);
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
        this.showConfirmModal = false;
      })
      .finally(() => {
        importModalModule.setIsUploading(false);
      });
  }
}
